<template>
  <div class="page-channel">
    <van-image width="100vw" height="auto" fit="cover" :src="BannerImage" />
    <div class="page-channel-content">
      <div class="content-name">勤奋笃实，追求卓越</div>
      <div class="content-des">做有温度的教育，办有品质的学校</div>
      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span>1. 学生姓名
        </div>
        <div class="content-item-content">
          <van-field
            label-width="0px"
            class="van-field-custom"
            v-model="state.form.realName"
            placeholder="请输入"
          ></van-field>
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span>2. 性别
        </div>
        <div class="content-item-content">
          <van-radio-group v-model="state.form.sex" shape="dot">
            <van-radio icon-size="18px" :name="1">男</van-radio>
            <van-radio icon-size="18px" style="margin-top: 8px" :name="2"
              >女</van-radio
            >
          </van-radio-group>
        </div>
      </div>
      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span>3. 年级
        </div>
        <div class="content-item-content">
          <van-radio-group v-model="state.form.grade" shape="dot">
            <van-radio icon-size="18px" :name="1">应届高三</van-radio>
            <van-radio icon-size="18px" style="margin-top: 8px" :name="2"
              >往届</van-radio
            >
          </van-radio-group>
        </div>
      </div>

      <div class="content-item" v-if="state.form.grade == 2">
        <div class="content-item-title">4. 高考分数</div>
        <div class="content-item-content">
          <van-field
            type="number"
            label-width="0px"
            class="van-field-custom"
            v-model="state.form.score"
            placeholder="请输入"
          ></van-field>
        </div>
      </div>

      

      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span
          >{{ state.form.grade == 2 ? "5" : "4" }}. 联系方式
        </div>
        <div class="content-item-content">
          <van-field
            label-width="0px"
            type="digit"
            class="van-field-custom"
            v-model="state.form.telephone"
            placeholder="请输入"
            maxlength="11"
          ></van-field>
        </div>
      </div>

      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span
          >{{ state.form.grade == 2 ? "6" : "5" }}. 选科
        </div>
        <div class="content-item-content">
          <van-radio-group v-model="state.form.subject" shape="dot">
            <van-radio icon-size="18px" name="1">物化生</van-radio>
            <van-radio icon-size="18px" style="margin-top: 8px" name="2"
              >物化政</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="3"
              >物化地</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="4"
              >物生政</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="5"
              >物地政</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="6"
              >物生地</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="7"
              >史生政</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="8"
              >史化政</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="9"
              >史地政</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="10"
              >史化生</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="11"
              >史生地</van-radio
            >
            <van-radio icon-size="18px" style="margin-top: 8px" name="12"
              >史化地</van-radio
            >
          </van-radio-group>
        </div>
      </div>

      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span
          >{{ state.form.grade == 2 ? "7" : "6" }}. 是否为艺体生
        </div>
        <div class="content-item-content">
          <van-radio-group v-model="state.form.isArt" shape="dot">
            <van-radio icon-size="18px" name="1">是</van-radio>
            <van-radio icon-size="18px" style="margin-top: 8px" name="2"
              >否</van-radio
            >
          </van-radio-group>
        </div>
      </div>

      <div class="content-item">
        <div class="content-item-title">
          <span class="item-error">*</span
          >{{ state.form.grade == 2 ? "8" : "7" }}. 原就读学校
        </div>
        <div class="content-item-content">
          <van-field
            label-width="0px"
            class="van-field-custom"
            v-model="state.form.oldSchoolName"
            placeholder="请输入"
          ></van-field>
        </div>
      </div>

      <div class="footer-wrap">
        <button
          class="submit-btn operation-btn"
          style="background: #2672ff"
          @click="handleSumit"
        >
          提交
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import BannerImage from "@/assets/bao_bg.jpg";
import { queryApplyFormAdd } from "@/api/user";
import { useRoute } from "vue-router";
import { showToast, showDialog } from "vant";

export default defineComponent({
  name: "RegistrationChannel",

  components: {},

  setup() {
    const route = useRoute();

    const defaultForm = {
      realName: null,
      sex: null,
      grade: null,
      score: null,
      telephone: null,
      isArt: null,
      subject: null,
      oldSchoolName: null,
      createOrg: route?.query?.org,
    };

    const checkPhone = (val) => /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(val);

    const state = reactive({
      list: [],
      form: {
        ...defaultForm
      },
    });

    onMounted(() => {
      document.title = '欢迎了解优益优全日制学校';
    });

    const handleSumit = async () => {
      if (!state.form.realName) {
        showToast("请填写学生姓名");
        return;
      }
      if (!state.form.sex) {
        showToast("请选择性别");
        return;
      }
      if (!state.form.grade) {
        showToast("请选择年级");
        return;
      }
      if (!state.form.isArt) {
        showToast("请选择是否为艺体生");
        return;
      }
      if (!state.form.telephone) {
        showToast("请填写联系方式");
        return;
      }

      if(!checkPhone(state.form.telephone)) {
        showToast("请输入正确的手机号码");
        return;
      }

      if (!state.form.subject) {
        showToast("请选择选科");
        return;
      }

      if (!state.form.oldSchoolName) {
        showToast("请填写原就读学校");
        return;
      }

      try {
        const result = await queryApplyFormAdd(state.form);
        if (result.code == "00") {
          showDialog({
            title: '温馨提示',
            message: '提交成功，工作人员将尽快与您联系',
          }).then(() => {
            // on close
            state.form ={
              ...defaultForm
            }
          });
          
        } else {
          showToast(result.message);
        }
      } catch (err) {
        showToast("提交失败");
      }
    };

    return {
      BannerImage,
      state,
      handleSumit,
      checkPhone,
    };
  },
});
</script>

<style lang="scss" scoped>
.page-channel {
  background: #e9f1f8;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
  padding: 0;
  margin: 0;
  z-index: 99;
  position: absolute;
}

.page-channel-content {
  background: #ffffff;
  border-top-right-radius: 28px;
  border-top-left-radius: 28px;
  width: calc(100% - 40px);
  height: auto;
  padding: 20px;
  margin-top: -28px;
  z-index: 999;
  position: absolute;
  padding-bottom: 64px;
}

.page-channel-content {
}

.content-name {
  font-size: 24px;
  margin-bottom: 8px;
  text-align: center;
  color: #333;
  display: block !important;
  font-weight: 500;
}

.content-des {
  margin: 0 0 32px;
  color: #666;
  display: block;
  font-size: 16px;
  text-align: center;
}

.content-item {
  margin-bottom: 40px;
}
.content-item-title {
  color: #333;
  font-weight: 500;
  margin-bottom: 8px;
  font-size: 18px;
  text-align: left;
  position: relative;
}

.van-field-custom {
  min-height: 39px !important;
  height: 39px !important;
  background-color: rgba(241, 243, 246, 0.8) !important;
  color: #333 !important;
  font-size: 16px !important;
  line-height: 39px !important;
  padding: 0 !important;
}

.van-field-custom {
  :deep(.van-field__control) {
    padding: 0 12px !important;
    height: 39px !important;
  }
  :deep(.van-field__control:focus) {
    border: 1px solid rgb(38, 114, 255) !important;
    caret-color: rgb(38, 114, 255) !important;
  }
}

.footer-wrap {
  display: flex;
  width: 100%;
  justify-content: center;
}

.submit-btn {
  line-height: 1.4;
  width: 180px;
}

.operation-btn {
  background: #2672ff;
  border: none;
  border-radius: 4px;
  box-sizing: border-box;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  height: 46px;
  line-height: 1.4;
  position: relative;
  text-align: center;
  width: 220px;
}

.item-error {
  color: #ff6d56;
  float: left;
  font-size: 12px;
  font-weight: 500;
  height: 18px;
  left: -1px;
  position: absolute;
  top: 6px;
  transform: translateX(-100%);
  width: 7px;
}
</style>